import React, { FC, useCallback } from 'react'
import { ReceivingFileModel } from 'Models'
import { UploadDropzoneWithoutStyle } from 'LibNeo'
import { UploadDropzoneProps } from 'Modules'

export const UploadDropzone: FC<UploadDropzoneProps> = React.forwardRef(
	(
		{
			children,
			multiple = false,
			accept,
			disableClick,
			minSize,
			maxSize,
			callbackWhileFileAccept,
			callbackWhileFileReject,
			width,
		},
		ref
	) => {
		const onDropFiles = useCallback(
			(acceptFiles: ReceivingFileModel[], rejectFiles?: ReceivingFileModel[]) => {
				if (disableClick) {
					return
				}

				if (rejectFiles?.length) {
					callbackWhileFileReject?.(acceptFiles, rejectFiles)
					return
				}

				if (acceptFiles?.length) {
					callbackWhileFileAccept?.(acceptFiles, rejectFiles)
				}
			},
			[callbackWhileFileReject, callbackWhileFileAccept]
		)

		return (
			<UploadDropzoneWithoutStyle
				ref={ref}
				multiple={multiple}
				accept={accept}
				disableClick={disableClick}
				minSize={minSize}
				maxSize={maxSize}
				onDrop={onDropFiles}
				width={width}
			>
				{children}
			</UploadDropzoneWithoutStyle>
		)
	}
)
